import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SuiContainer, SuiButton, SuiTooltipPopover } from '@splashthat/sui';
import ArrowLeft from 'common/icons/ArrowLeft';
import LockIcon from 'common/icons/LockFill';

import { filterMarkup } from '../../utils/filterMarkupHelper';

const PANEL_HEADLINE = 'Editing';
const LOCKED_TOOLTIP_CONTENT = 'Locked Question';

const baseClassName = 'EditViewHeader';

const SuiContainerAlignedToTheRight = styled(SuiContainer)`
    margin-left: auto;
    flex-shrink: 0;
`;

const SuiButtonForLockIcon = styled(SuiButton)`
    /* Since the lock is not a real button, but we use SuiButton to be consistent */
    /* with other icons, we want to override the color difference when it's active or focused */
    &:active,
    &:focus {
        color: currentColor;
    }

    /* better cursor option for this lock icon */
    cursor: not-allowed;
`;

const BackButton = styled(SuiButton)`
    &&:hover {
        color: ${({ theme }) => theme.palette.grayscale.gray65};
    }
`;

const EditViewHeader = ({ label, saveEditFormNode, locked }) => (
    <SuiContainer className={baseClassName} variation="flex-horizontal flex-horizontal-left flex-inherit">
        <SuiContainer>
            <BackButton
                data-skip-autofocus
                variation="navigation"
                size="small"
                onClick={saveEditFormNode}
                icon={<ArrowLeft />}
                data-qa="form-builder-back-button"
            />
        </SuiContainer>

        <SuiContainer variation="flex-group">
            <h3 className={`${baseClassName}__header-title`}>{PANEL_HEADLINE}</h3>
            <h2 className={`${baseClassName}__header-text`}>{filterMarkup(label)}</h2>
        </SuiContainer>

        <SuiContainerAlignedToTheRight variation="flex-group">
            {locked && (
                <SuiTooltipPopover content={LOCKED_TOOLTIP_CONTENT} openDelayed>
                    <SuiButtonForLockIcon
                        variation="navigation"
                        size="small"
                        icon={<LockIcon />}
                        data-qa="form-builder-locked-icon"
                        tabIndex="-1" // so that it isn't selected when tabbing
                    />
                </SuiTooltipPopover>
            )}
        </SuiContainerAlignedToTheRight>
    </SuiContainer>
);

EditViewHeader.propTypes = {
    label: PropTypes.string,
    locked: PropTypes.bool.isRequired,
    saveEditFormNode: PropTypes.func.isRequired,
};

EditViewHeader.defaultProps = {
    label: '',
};

export default EditViewHeader;
